import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mission',
  templateUrl: './mission.component.html',
  styleUrls: ['./mission.component.scss']
})
export class MissionComponent implements OnInit {
  leaders = [
    {
      letter: 'E',
      description: 'Lead towards a caring community and a place of transformation.',
      bgImage: 'assets/img/home/mission/1.jpg', // Uncomment when image is ready
      color: '#4ade80' // Light green
    },
    {
      letter: 'R',
      description: 'Encourage to continually develop their God given talents in the spiritual, intellectual, physical, cultural and social spheres.',
      bgImage: 'assets/img/home/mission/2.jpg', // Uncomment when image is ready
      color: '#a78bfa' // Light purple
    },
    {
      letter: 'U',
      description: 'Appreciate and be content with the blessings of the Lord.',
      bgImage: 'assets/img/home/mission/3.jpg', // Uncomment when image is ready
      color: '#5eead4' // Light teal
    },
    {
      letter: 'D',
      description: 'Define our existence.',
      bgImage: 'assets/img/home/mission/4.jpg', // Uncomment when image is ready
      color: '#f87171' // Light red
    },
    {
      letter: 'I',
      description: 'Emerge with a meaningful role within the school and the society.',
      bgImage: 'assets/img/home/mission/5.jpg', // Uncomment when image is ready
      color: '#fb923c' // Light orange
    },
    {
      letter: 'T',
      description: 'Revive blissfully at any given situation.',
      bgImage: 'assets/img/home/mission/6.jpg', // Uncomment when image is ready
      color: '#e879f9' // Light pink
    },
    {
      letter: 'E',
      description: 'Self awareness and self disciplined.',
      bgImage: 'assets/img/home/mission/7.jpg', // Uncomment when image is ready
      color: '#fbbf24' // Light amber
    }
  ];
  constructor() { }

  ngOnInit(): void {
  }

}
